export default __webpack_public_path__ + "static/media/vishaka_bg.24f52d74.jpg";